import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {sorterNum} from 'Utils'
import {Table, Input} from 'antd'
import moment from 'moment-timezone'

import style from './style.sass'

@inject('store') @observer
class Metrics extends Component {
  search = (e) => {
    this.props.store.backtest.tables.filterTable(e.target.value)
  }
  changePage = (page) => {
    this.props.store.backtest.tables.fetchMetrics(this.props.id, page.current)
  }
  downloadCsv = () => {
    this.props.store.backtest.tables.saveFile('metrics', this.props.id, 'csv')
  }
  downloadXlsx = () => {
    this.props.store.backtest.tables.saveFile('metrics', this.props.id, 'xlsx')
  }
  render() {
    const columns = [{
      title: 'Date',
      dataIndex: 'date',
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (x) => {
        if (x == null) {
          return <span>-</span>
        } else {
          const dt = moment(x).tz('US/Eastern')
          if (!dt._isValid) {
            return <span>-</span>
          } else {
            return <span>{dt.format('L')}</span>
          }
        }
      }
    }, {
      title: 'PnL',
      dataIndex: 'pnl',
      sorter: (a, b) => sorterNum(a.pnl, b.pnl)
    }]

    const {count, size, page, loading} = this.props.store.backtest.tables.metrics
    return(
      <div styleName='wrapper'>
        <div className='card-box'>
          <div styleName='table-controls'>
            <div styleName='buttons'>
              <button onClick={this.downloadCsv}>Download CSV</button>
              <button onClick={this.downloadXlsx}>Download XLSX</button>
            </div>
            <Input onChange={this.search} placeholder='Search' styleName='search'/>
          </div>
          <Table
            onChange={this.changePage}
            style={{margin: '6px 0'}}
            dataSource={this.props.store.backtest.tables.filteredMetrics}
            columns={columns}
            size='small'
            loading={loading}
            pagination={{
              pageSize: size,
              total: count,
              current: page
            }}
            locale={loading ? {
              emptyText: 'Loading'
            } : {
              emptyText: 'No Data'
            }}
          />
        </div>
      </div>
    )
  }
}

export default Metrics
